import React, { createContext, useReducer, useContext } from "react";
import { Alert, Snackbar } from "@mui/material";
import {
  IconAlertCircle,
  IconFlag,
  IconInfoCircle,
  IconTrophy,
} from "@tabler/icons-react";

type AlertaProps = {
  mensagem: string;
  severidade: "success" | "info" | "warning" | "error";
  action?: React.ReactNode;
};

type SnackbarState = {
  alerta: AlertaProps;
  open: boolean;
};

const initialState: SnackbarState = {
  alerta: { mensagem: "", severidade: "info", action: undefined },
  open: false,
};

export const iconMapping = {
  success: <IconTrophy size={24} />,
  info: <IconInfoCircle size={24} />,
  error: <IconFlag size={24} />,
  warning: <IconAlertCircle size={24} />,
};
const SnackBarStore = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(SnackbarReducer, initialState);
  const handleClose = () => {
    dispatch({ type: "DISMISS" });
  };

  return (
    <SnackBarContext.Provider value={dispatch}>
      <Snackbar
        key={state.alerta.mensagem}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={state.open}
        autoHideDuration={1000 * 10}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          variant="filled"
          iconMapping={iconMapping}
          severity={state.alerta.severidade}
          action={state.alerta.action}
        >
          {state.alerta.mensagem}
        </Alert>
      </Snackbar>
      {children}
    </SnackBarContext.Provider>
  );
};

const SnackBarContext = createContext<
  React.Dispatch<{ type: "ALERT" | "DISMISS"; payload?: AlertaProps }>
>(() => {});
export default SnackBarStore;

export const useSnackBar = () => {
  const snackbar = useContext(SnackBarContext);
  return snackbar;
};

const SnackbarReducer = (
  state: SnackbarState,
  action: { type: "ALERT" | "DISMISS"; payload?: AlertaProps }
): SnackbarState => {
  switch (action.type) {
    case "ALERT":
      return {
        ...state,
        alerta: { ...state.alerta, ...action.payload },
        open: true,
      };
    case "DISMISS":
      return {
        alerta: { mensagem: "", severidade: "info" },
        open: false,
      };
    default:
      return state;
  }
};
